import DeleteClientContactContainer from "./DeleteClientContactContainer";
export default DeleteClientContactContainer;
